function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import withStyles from 'isomorphic-style-loader/withStyles';
import map from 'lodash/map';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import SidebarPersonsLoader from 'components/Loaders/SidebarPersonsLoader';
import Dots from 'svg/dots.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './FamilyList.pcss';
var _React_PureComponent;
class FamilyList extends (_React_PureComponent = React.PureComponent) {
    onFetchFamilyLinks() {
        if (process.env.BROWSER && !this.props.isClientInitialized) {
            return;
        }
        this.props.onFetchFamilyLinks();
    }
    async onOpenMenu(evt, familyLinkId) {
        evt.preventDefault();
        evt.stopPropagation();
        await this.props.onCloseDropdown();
        this.props.onOpenDropdown(`${constants.FAMILY_MEMBER_DROPDOWN}-${familyLinkId}`);
    }
    onRevokeAccess(evt, familyLinkInvitation) {
        evt.preventDefault();
        this.props.onSetFormContext(constants.REVOKE_FAMILY_ACCESS_FORM, familyLinkInvitation);
        this.props.onOpenModal(constants.REVOKE_FAMILY_ACCESS_MODAL);
    }
    get approvedFamilyLinkInvitations() {
        return this.props.familyLinkInvitations.filter((fl)=>fl.status === 'Approved');
    }
    renderAvatar(person) {
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: person.avatar,
            name: [
                person.firstName,
                person.lastName
            ],
            className: styles.item__avatar,
            imgClassName: styles.item__avatar__img,
            initialsClassName: styles.item__avatar__initials
        });
    }
    renderFamilyLinkInvitationMenu(familyLinkInvitation) {
        const { familyLinkId } = familyLinkInvitation;
        if (this.props.openDropdownId !== `${constants.FAMILY_MEMBER_DROPDOWN}-${familyLinkId}`) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                width: 0
            },
            animate: {
                width: 'auto'
            },
            exit: {
                width: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container dropdownMenu__container--oposite ml-3",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "dropdownMenu__actions",
                children: /*#__PURE__*/ _jsx("li", {
                    className: "dropdownMenu__action",
                    children: /*#__PURE__*/ _jsx(Link, {
                        to: "",
                        onClick: (evt)=>this.onRevokeAccess(evt, familyLinkInvitation),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.revokeAccess))
                    })
                })
            })
        });
    }
    renderFamilyLinkInvitation(familyLinkInvitation) {
        const { familyLinkId, requestor } = familyLinkInvitation;
        return /*#__PURE__*/ _jsx("li", {
            className: cn(styles.item__sidebarList, styles['item__sidebarList--noHover']),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-block",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row align-items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-auto pr-2",
                                        children: this.renderAvatar(requestor)
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ _jsxs("p", {
                                            "data-hj-suppress": true,
                                            className: styles.item__name,
                                            children: [
                                                requestor.firstName,
                                                " ",
                                                requestor.lastName
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn('col-auto', styles.item__menu),
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                to: "",
                                onClick: (evt)=>this.onOpenMenu(evt, familyLinkId),
                                children: /*#__PURE__*/ _jsx(Dots, {
                                    className: "dropdownMenu__icon"
                                })
                            }),
                            /*#__PURE__*/ _jsx(AnimatePresence, {
                                children: this.renderFamilyLinkInvitationMenu(familyLinkInvitation)
                            })
                        ]
                    })
                ]
            })
        }, familyLinkId);
    }
    renderFamilyLinkRequest(familyLinkRequest) {
        const { familyLinkId: routeFamilyLinkId } = this.props.route.params;
        const { familyLinkId, encryptedExchangeToken, invitee = {} } = familyLinkRequest;
        const patientSlug = getSlug(`${invitee.firstName} ${invitee.lastName}`);
        const linkUrl = encryptedExchangeToken ? this.context.getUrl('family-member-results', {
            patientSlug,
            familyLinkId
        }) : '';
        const isActive = this.props.route.name === 'family-member-results' && +routeFamilyLinkId === familyLinkId;
        return /*#__PURE__*/ _jsx("li", {
            className: cn(styles.item__sidebarList, {
                [styles['item--active']]: isActive
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: "row align-items-center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx(Link, {
                        to: linkUrl,
                        className: cn('d-block', {
                            isDisabled: !encryptedExchangeToken
                        }),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-auto pr-2",
                                    children: this.renderAvatar(invitee)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ _jsxs("p", {
                                        "data-hj-suppress": true,
                                        className: styles.item__name,
                                        children: [
                                            invitee.firstName,
                                            " ",
                                            invitee.lastName
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        }, familyLinkId);
    }
    renderInvitations(approvedFamilyLinkInvitations) {
        if (!approvedFamilyLinkInvitations.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("hr", {}),
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--small text--bold px-3 py-2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.familyLinkInvitations))
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: styles.items,
                    children: map(approvedFamilyLinkInvitations, (familyLink)=>this.renderFamilyLinkInvitation(familyLink))
                })
            ]
        });
    }
    renderRequests(familyLinkRequests) {
        if (!familyLinkRequests.length) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("ul", {
                className: styles.items,
                children: map(familyLinkRequests, (familyLink)=>this.renderFamilyLinkRequest(familyLink))
            })
        });
    }
    render() {
        if (this.props.isInProgress) {
            return /*#__PURE__*/ _jsx(SidebarPersonsLoader, {
                itemsNumber: 2
            });
        }
        const { familyLinkRequests } = this.props;
        const { approvedFamilyLinkInvitations } = this;
        if (!approvedFamilyLinkInvitations.length && !familyLinkRequests.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderRequests(familyLinkRequests),
                this.renderInvitations(approvedFamilyLinkInvitations)
            ]
        });
    }
    constructor(props){
        super(props);
        this.onFetchFamilyLinks();
    }
}
_define_property(FamilyList, "contextType", AppContext);
_define_property(FamilyList, "propTypes", {
    // Implicit props
    familyLinkInvitations: PropTypes.arrayOf(shapes.familyLinkInvitation),
    familyLinkRequests: PropTypes.arrayOf(shapes.familyLinkRequest),
    patientProfile: PropTypes.shape({
        patientProfileId: PropTypes.number.isRequired
    }),
    cgProfile: PropTypes.shape({
        cgProfileId: PropTypes.number.isRequired
    }),
    isInProgress: PropTypes.bool,
    isClientInitialized: PropTypes.bool,
    openDropdownId: PropTypes.string,
    route: App.shapes.route,
    // Implicit actions
    onFetchFamilyLinks: PropTypes.func,
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func,
    onOpenModal: PropTypes.func,
    onSetFormContext: PropTypes.func
});
const mapStateToProps = (state)=>({
        familyLinkInvitations: selectors.familyLinkInvitations(state),
        familyLinkRequests: selectors.familyLinkRequests(state),
        isInProgress: selectors.isFetchFamilyLinksInProgress(state),
        patientProfile: Account.selectors.patientProfile(state),
        cgProfile: Account.selectors.cgProfile(state),
        isClientInitialized: App.selectors.isClientInitialized(state),
        openDropdownId: App.selectors.dropdown(state),
        route: App.selectors.route(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchFamilyLinks: ()=>dispatch(actions.fetchFamilyLinkRequests()),
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown()),
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onSetFormContext: (formName, contextData)=>dispatch(App.actions.setFormContext(formName, contextData))
    });
const ConnectedFamilyList = connect(mapStateToProps, mapDispatchToProps)(FamilyList);
export default withStyles(styles)(ConnectedFamilyList);
